import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import { Button, Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import { tableTdIconStyles1 } from "../../../config/styles";
import { constructIds } from '../../../config/common';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import Hyperlink from '../../atoms/links/Hyperlink';
import Strip from '../../atoms/Wrappers/Strip';
import ViewRoutingRule from './ViewRoutingRule'
import { SearchTextField } from '../blueprint/SearchField';
import { stableSort, getComparator } from '../../../services/entities/common';
import { StyledTableCellHead } from '../../atoms/table/tableStyles';
import { invokeGetService } from "../../../store/global/actions";
import CircularProgress from '@material-ui/core/CircularProgress';
import { getInnerScreenRender, getReRender } from '../../../store/global/selectors';
import Alert from '@material-ui/lab/Alert/Alert';
import ExpndedRoutingRule from './ExpandedRoutingRule';
import TransactionDialog from '../alerts/CreateTransactionAlert';


export default function ListRoutingRules({ element, setAction, setcheckmultiplerrDef, isRrdefRequired }) {
    const dispatch = useDispatch();
    const [events, setEvents] = useState([]);
    const [clusterlets, setClusterlets] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isViewRoutingRule, setIsViewRoutingRule] = useState(null);
    const innerScreenRender = useSelector(getInnerScreenRender);

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [allRrdefs, setAllRrdefs] = useState([]);
    const [expandedIndices, setExpandedIndices] = useState([]);
    const [openAddTransactionDialog, setOpenAddTransactionDialog] = useState(false);
    const [showNoTransactionAlert, setShowNoTransactionAlert] = useState(false);
    const reRender = useSelector(getReRender);
    

    const excludeAttributesList = ['name', 'tcmd', 'dir', 'commandtype',  'ttype', 'tinstance']


    const [filteredRrdefs, setFilteredRrdefs] = useState([]);
    const apiPath = element.type === 'external_function' ? 'getClusterletAssociatedRoutingRules' : 'getEventRoutingRoule'

    const filterRrdefs = (rrdefs) => {
        if (rrdefs === undefined) {
            return [];
        }

        return rrdefs?.filter(row => (
            row.name.toLowerCase().includes(searchQuery.toLowerCase())
            || (events.find(event => event._id === row.attributes.tcmd) != undefined ? events.find(event => event._id === row.attributes.tcmd)?.name : "").toLowerCase().includes(searchQuery.toLowerCase())
            || (row.attributes.dir !== undefined ? row.attributes.dir : '').toLowerCase().includes(searchQuery.toLowerCase())
            || (clusterlets?.find(cl => cl._id === row.attributes.ttype)?.name !== undefined ? clusterlets.find(cl => cl._id === row.attributes.ttype)?.name : '').toLowerCase().includes(searchQuery.toLowerCase())
            || (row.attributes.tinstance !== undefined ? row.attributes.tinstance : '').toLowerCase().includes(searchQuery.toLowerCase())
            || (row.attributes.commandtype === "req" ? 'Request' : row.attributes.commandtype === "res" ? 'Response' : 'NIL').toLowerCase().includes(searchQuery.toLowerCase())
            || (row.attributes.host !== undefined ? row.attributes.host : '').toLowerCase().includes(searchQuery.toLowerCase())
            || (row.attributes.code !== undefined ? row.attributes.code.toString() : '').toLowerCase().includes(searchQuery.toLowerCase())
        ))

    }

    const modifyAllRrdefs = ({ rrdefs, clusterlets, events }) => {
        let modifiedRrdefs = []

        rrdefs?.forEach(rrdef => {
            let clusterletType = clusterlets?.find(item => item._id === rrdef.attributes.ttype)
            if (clusterletType !== undefined) rrdef.clusterletType = clusterletType?.name;

            let event = events?.find(item => item._id === rrdef.attributes.tcmd)
            if (event !== undefined) rrdef.eventName = event.name

            rrdef.commandType = (rrdef.attributes.commandtype === "req") ? 'Request' : (rrdef.attributes.commandtype === "res") ? 'Response' : 'NIL'
            rrdef.targetInstance = rrdef.attributes.tinstance !== undefined ? rrdef.attributes.tinstance : ""

            modifiedRrdefs.push(rrdef);
        })

        return modifiedRrdefs
    }

    const findDelegateAssociatedTransaction = (transactions=[]) => {
        try {
            if(element?.type === "external_function"){
                const filteredTxns = transactions?.filter(item => item?.clusterlets?.map(clst => clst?.id)?.includes(element?.id) ) || []
                setShowNoTransactionAlert(filteredTxns?.length > 0 ? false : true)
            }
        } catch (error) {
            console.error(`Finding delegate associated transactions failed. ${error}`);
        }
    }

    
    const fetchRoutingRules = () => {
        setLoading(true);
        dispatch(invokeGetService(apiPath, [element.id]))
            .then((response) => {
                setAllRrdefs(modifyAllRrdefs({ rrdefs: response?.data?.rrdefs, clusterlets: response?.data?.clusterlets, events: response?.data?.events }))
                setFilteredRrdefs(modifyAllRrdefs({ rrdefs: response?.data?.rrdefs, clusterlets: response?.data?.clusterlets, events: response?.data?.events }))

                setClusterlets(response?.data?.clusterlets)
                setEvents(response?.data?.events)
                setTransactions(response?.data?.transactions)
                setLoading(false);


                findDelegateAssociatedTransaction(response?.data?.transactions);
            })
    }

    useEffect(() => {
        fetchRoutingRules();
    }, [innerScreenRender, reRender])


    useEffect(() => {
        setFilteredRrdefs(filterRrdefs(allRrdefs));
    }, [searchQuery])


    const toggleItem = (index) => {
        if (expandedIndices.includes(index)) {
          setExpandedIndices(expandedIndices.filter((i) => i !== index)); // Collapse item
        } else {
          setExpandedIndices([...expandedIndices, index]); // Expand item
        }
    };

    const createTransaction = () => {
        setOpenAddTransactionDialog(true);
    }

    return (
        <>
            {!showNoTransactionAlert && isViewRoutingRule == null && <SearchTextField setSearchQuery={setSearchQuery} searchQuery={searchQuery} />}
            
            {isRrdefRequired === false &&
                <Grid container direction={"row"} spacing={3} style={{marginBottom: 5}} >
                    <Grid item xs={12}>
                        <Alert id="rrdef_alert" icon={false} severity="info">No routing rules required</Alert>
                    </Grid>
                </Grid>
            }

            {isViewRoutingRule == null && <>
                {showNoTransactionAlert ? (
                  <Alert id="no_transation_alert" severity="info"> This delegate is not associated with any transaction. <a id={"create_transaction_link"} href='#' onClick={createTransaction}>Create a new transaction</a></Alert>    
                ) : (
                   

                <TableContainer component={Paper} style={{borderRadius: 0, boxShadow: 'none'}}>
                    <Table aria-label="customized table" className="rrdef_list_table" >
                        <TableHead>
                            <TableRow >
                                {/* <StyledTableCellHead align='center' > #   </StyledTableCellHead> */}
                                <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'name'}> Name</StyledTableCellHead>
                                <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'eventName'}> Event</StyledTableCellHead>
                                <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'attributes.dir'}> Direction</StyledTableCellHead>
                                <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'commandType'}> Command Type</StyledTableCellHead>
                                <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'clusterletType'}> Clusterlet</StyledTableCellHead>
                                <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'targetInstance'}> Clusterlet Instance</StyledTableCellHead>
                                <StyledTableCellHead align='left' style={{ minWidth: 80 }} > Actions</StyledTableCellHead>
                                <StyledTableCellHead align='right'></StyledTableCellHead>
                            </TableRow>

                        </TableHead>
                        <TableBody>
                            {loading ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={10} component="td" style={{ padding: 15 }}>
                                        Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                    </StyledTableCell>
                                </StyledTableRow>
                                : filteredRrdefs === undefined || filteredRrdefs?.length === 0 ?
                                    <StyledTableRow>
                                        <StyledTableCell align={'center'} colSpan={10} component="td" style={{ padding: 15 }}>
                                            No routing rules available.
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    :
                                    stableSort(filteredRrdefs, getComparator(order, orderBy))?.map((rrdef, index) => (
                                        <>
                                        
                                        
                                        <StyledTableRow key={rrdef._id} className={`rrdef_item_table_row  item_${rrdef.name}`}>


                                            {/* Rrdef name */}
                                            <StyledTableCell align={'left'} component="td"  >
                                                <Tooltip title={rrdef?.name}>
                                                    <span>{rrdef.name}</span>
                                                </Tooltip>
                                            </StyledTableCell>

                                            {/* Associated event */}
                                            <StyledTableCell align={'left'} component="td" style={{ padding: '5px 12px' }} >
                                                <Hyperlink id={rrdef.attributes.tcmd} type={'event'} transactionId={transactions.find(transaction => transaction.events.find(event => event.id == rrdef.attributes.tcmd))?._id} screen={'transaction'} item={events.find(e => e._id == rrdef.attributes.tcmd)} name={events.find(e => e._id == rrdef.attributes.tcmd)?.name} mode={'edit'} protocol={clusterlets.find(c => c?._id === rrdef?.attributes?.delegate)?.attributes?.type}>
                                                    {events.filter(e => e._id === rrdef.attributes.tcmd)?.map(item => <Strip length={20}>{item.name}</Strip>)}
                                                </Hyperlink>
                                            </StyledTableCell>

                                            {/* Direction */}
                                            <StyledTableCell align={'left'} component="td" >
                                                {rrdef.attributes.dir}
                                            </StyledTableCell>

                                            {/* Command type */}
                                            <StyledTableCell align={'left'} component="td" >
                                                {(rrdef.attributes.commandtype === "req") ? 'Request' : (rrdef.attributes.commandtype === "res") ? 'Response' : 'NIL'}
                                            </StyledTableCell>

                                            {/* Clusterlet type */}
                                            <StyledTableCell align={'left'} component="td" >
                                                <Hyperlink id={rrdef.attributes.ttype} type={constructIds.find(element => element.id === clusterlets.find(e => e._id === rrdef.attributes.ttype)?.type)?.type} name={clusterlets.find(e => e._id === rrdef.attributes.ttype)?.name} desc={clusterlets.find(e => e._id === rrdef.attributes.ttype)?.attributes?.desc}>{clusterlets.find(e => e._id === rrdef.attributes.ttype)?.name}</Hyperlink>
                                            </StyledTableCell>

                                            {/* Target instance */}
                                            <StyledTableCell align={'left'} component="td" >
                                                {rrdef.attributes.tinstance}
                                            </StyledTableCell>

                                            {/* Actions */}
                                            <StyledTableCell align="right" style={{
                                             }}>


                                               { isRrdefRequired && <Tooltip title="Edit routing rule">
                                                    <EditIcon style={tableTdIconStyles1} className="edit_rrdef" color="primary" onClick={() => setAction({ action: 'edit_rrdef', id: rrdef._id, item: rrdef })} />
                                                </Tooltip>}


                                                <Tooltip title="Delete routing rule">
                                                    <DeleteIcon style={tableTdIconStyles1} color="error" className="delete_rrdef" onClick={() => setAction({ action: 'delete_rrdef', id: rrdef._id, item: rrdef })} />
                                                </Tooltip>


                                            </StyledTableCell>
                                            <StyledTableCell>
                                                <Tooltip title={expandedIndices.includes(index) ? "Collapse routing rule" : "Expand routing rule"} >
                                                    { expandedIndices.includes(index) ? <ExpandLessRoundedIcon className="collapseRrdef"  onClick={() => toggleItem(index)}/>: <ExpandMoreRoundedIcon className="expandRrdef"  onClick={() => toggleItem(index)}/>}
                                                </Tooltip>
                                            </StyledTableCell>

                                        </StyledTableRow>
                                        
                                        {expandedIndices.includes(index) && (
                                            <StyledTableRow key={`view_${rrdef?._id}`} id={`expanded_item_${rrdef.name}`} className="expanded_row_rrdef" >
                                                   <StyledTableCell align={'center'} colSpan={8} component="td" style={{padding: 0, margin: 0}} >
                                                        <ExpndedRoutingRule excludeAttributesList={excludeAttributesList} item={rrdef} />
                                                    </StyledTableCell>
                                            </StyledTableRow>
                                        )}

                                        </>
                                    ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                 
                ) }
                
            </>}

            {/* View routing rule */}
            {isViewRoutingRule !== null && 
            <div >
                <ViewRoutingRule item={isViewRoutingRule} />
                <Button onClick={() => setIsViewRoutingRule(null)} color="primary" variant="contained" style={{ marginTop: '20px' }}>
                    Back
                </Button>
            </div>}

            {/* Create transaction dialogue */}
            {openAddTransactionDialog && <TransactionDialog onClose={() => setOpenAddTransactionDialog(false)}/>}


        </>

    )
}
